import styles from '../assets/css/gapsy-dashboard.module.css';

const sessionDept = sessionStorage.getItem("dept") || "Unknown";
const DepartmentDropdown = ({ selectedPrefix, setSelectedPrefix, prefixes }) => {

  const sessionDept = sessionStorage.getItem("dept") || "Unknown";
  const dropdownItems = prefixes && prefixes.length > 0 ? prefixes : [sessionDept];

  // Helper function for display labels
  const getDisplayLabel = (dept) => (dept === "Finance" ? "Finance and Planning" : dept);

  return (
    <div className="table-on-homepage-only">
      <div className="dropdown">
        <button
          className="btn btn-light btn-sm dropdown-toggle department-dropdown-button-color text-nowrap"
          type="button"
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedPrefix ? getDisplayLabel(selectedPrefix) : "Select Department"}
        </button>
        <ul className={`dropdown-menu mt-1 ${styles.dropdownMenu}`} aria-labelledby="dropdownMenuButton">
          {dropdownItems
            .slice() // Create a copy of the array to avoid mutating the original
            .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
            .map((prefix, idx) => (
              <li key={idx}>
                <a
                  className={`dropdown-item small ${styles.dropdownItem}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedPrefix(prefix);
                  }}
                >
                  {getDisplayLabel(prefix)} {/* Display label */}
                </a>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export const FbcDepartmentDropdown = ({
  selectedDept,
  departments = [],
  setSelectedDept,
  showDropdown
}) => {
  if (!showDropdown || departments.length === 0) return null;

  return (
    <div className="table-on-homepage-only">
      <div className="dropdown position-absolute mt-n2 me-3 top-10 end-0">
        {/* <button
          className="btn btn-light btn-sm dropdown-toggle dropdown-button-color text-nowrap department-dropdown-button"
          type="button"
          id="departmentDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedDept || "Select Department"}
        </button> */}
        <button
          className="btn btn-light btn-sm dropdown-toggle dropdown-button-color text-nowrap department-dropdown-button"
          type="button"
          id="departmentDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {selectedDept === "Finance" ? "Finance and Planning" : selectedDept || "Select Department"}
        </button>

        {/* <ul className={`dropdown-menu mt-1 end-0 ${styles.dropdownMenu}`} aria-labelledby="departmentDropdown">
          {[...departments]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((dept) => (
              <li key={dept.id}>
                <a className={`dropdown-item small ${styles.dropdownItem}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedDept(dept.name);
                  }}
                >
                  {dept.name}
                </a>
              </li>
            ))}
        </ul> */}
        <ul className={`dropdown-menu mt-1 end-0 ${styles.dropdownMenu}`} aria-labelledby="departmentDropdown">
          {[...departments]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((dept) => (
              <li key={dept.id}>
                <a
                  className={`dropdown-item small ${styles.dropdownItem}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedDept(dept.name); // keep actual value
                  }}
                >
                  {dept.name === "Finance" ? "Finance and Planning" : dept.name}
                </a>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};


export default DepartmentDropdown;
